// removed by extract-text-webpack-plugin
module.exports = {"homeScreen":"src-components-PrintReturns-styles__homeScreen--2nqau","viewSwitcher":"src-components-PrintReturns-styles__viewSwitcher--3LHMt","active":"src-components-PrintReturns-styles__active--2Q9Pk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PrintReturns/styles.scss
// module id = 270
// module chunks = 0